<div class="ai-views" *ngIf="views?.length">
  <ng-container *ngFor="let view of views; trackBy: trackByIndex" [ngSwitch]="view.type">
    <!-- ========================= lead_list / contact_list ========================= -->
    <ng-container *ngSwitchCase="'lead_list'">
      <ng-container *ngTemplateOutlet="leadListTpl; context: { $implicit: asLeadList(view) }"></ng-container>
    </ng-container>

    <!-- ============================== lead_detail ============================== -->
    <div class="ai-view-block" *ngSwitchCase="'lead_detail'">
      <ng-container *ngTemplateOutlet="leadCardTpl; context: { $implicit: asLeadDetail(view).item, detail: true }"></ng-container>
    </div>

    <!-- ============================== lead_created ============================= -->
    <div class="ai-view-block ai-created" *ngSwitchCase="'lead_created'">
      <div class="ai-created__head">
        <span class="ai-created__icon"><i class="pi pi-check-circle"></i></span>
        <div>
          <strong>Lead created</strong>
          <span class="ai-created__name">{{ asLeadCreated(view).item.name || 'New lead' }}</span>
        </div>
      </div>
      <div class="ai-created__meta">
        <span class="ai-chip" *ngIf="asLeadCreated(view).item.lead_type">{{ asLeadCreated(view).item.lead_type }}</span>
        <span class="ai-chip" *ngIf="asLeadCreated(view).item.lead_status">{{ asLeadCreated(view).item.lead_status }}</span>
        <span class="ai-chip ai-chip--soft" *ngIf="asLeadCreated(view).item.project_attach === 'linked' && asLeadCreated(view).item.project_name">
          <i class="pi pi-building"></i> {{ asLeadCreated(view).item.project_name }}
        </span>
      </div>
      <p class="ai-created__hint" *ngIf="asLeadCreated(view).item.missing_optional?.length">
        <i class="pi pi-info-circle"></i>
        You can add later: {{ asLeadCreated(view).item.missing_optional?.join(', ') }}
      </p>
      <p class="ai-created__warn" *ngIf="asLeadCreated(view).item.project_attach === 'not_found'">
        <i class="pi pi-exclamation-triangle"></i>
        <ng-container *ngIf="asLeadCreated(view).item.project_name; else noProjName">
          Couldn’t link “{{ asLeadCreated(view).item.project_name }}” — that project wasn’t found.
        </ng-container>
        <ng-template #noProjName>The requested project wasn’t found, so it wasn’t linked.</ng-template>
      </p>
      <div class="ai-view-actions">
        <button type="button" class="ai-btn ai-btn--primary" (click)="emitOpenLead(asLeadCreated(view).item.id, asLeadCreated(view).item.project_id)">
          <i class="pi pi-external-link"></i> Open Lead
        </button>
      </div>
    </div>

    <!-- ===== write confirmations: lead_updated / follow_up_* / contact_logged / appointment_booked ===== -->
    <ng-container *ngSwitchCase="'lead_updated'">
      <ng-container *ngTemplateOutlet="confirmTpl; context: { $implicit: confirmCard(view) }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'follow_up_saved'">
      <ng-container *ngTemplateOutlet="confirmTpl; context: { $implicit: confirmCard(view) }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'follow_up_completed'">
      <ng-container *ngTemplateOutlet="confirmTpl; context: { $implicit: confirmCard(view) }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'contact_logged'">
      <ng-container *ngTemplateOutlet="confirmTpl; context: { $implicit: confirmCard(view) }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'appointment_booked'">
      <ng-container *ngTemplateOutlet="confirmTpl; context: { $implicit: confirmCard(view) }"></ng-container>
    </ng-container>

    <!-- ============================ appointment_list ========================== -->
    <div class="ai-view-block" *ngSwitchCase="'appointment_list'">
      <h6 class="ai-stats__title">Appointments</h6>
      <p class="ai-list__count" *ngIf="!asAppointmentList(view).items?.length">No appointments yet.</p>
      <div class="ai-appt" *ngFor="let a of asAppointmentList(view).items; trackBy: trackById">
        <span class="ai-appt__icon"><i class="pi" [ngClass]="a.is_inspection ? 'pi-home' : 'pi-calendar'"></i></span>
        <div class="ai-appt__body">
          <strong class="ai-appt__title">{{ a.title || 'Appointment' }}</strong>
          <span class="ai-appt__when" *ngIf="appointmentWhen(a)">{{ appointmentWhen(a) }}</span>
          <span class="ai-chip ai-chip--soft" *ngIf="a.type">{{ a.type }}</span>
        </div>
      </div>
    </div>

    <!-- ========================== my_appointment_list ========================= -->
    <div class="ai-view-block" *ngSwitchCase="'my_appointment_list'">
      <div class="ai-list__head">
        <span class="ai-list__count">
          {{ asMyAppointmentList(view).appointments_count || 0 }} appointment{{ asMyAppointmentList(view).appointments_count === 1 ? '' : 's' }}
          <ng-container *ngIf="asMyAppointmentList(view).inspections_count">
            · {{ asMyAppointmentList(view).inspections_count }} inspection{{ asMyAppointmentList(view).inspections_count === 1 ? '' : 's' }}
          </ng-container>
        </span>
        <span class="ai-grid__view" *ngIf="asMyAppointmentList(view).period">· {{ asMyAppointmentList(view).period }}</span>
      </div>
      <p class="ai-list__count" *ngIf="!asMyAppointmentList(view).items?.length">No appointments in this period.</p>
      <button
        type="button"
        class="ai-appt ai-appt--clickable"
        *ngFor="let a of asMyAppointmentList(view).items; trackBy: trackById"
        (click)="openAppointmentLead(myAppointmentLeadId(a))">
        <span class="ai-appt__icon"><i class="pi" [ngClass]="a.is_inspection ? 'pi-home' : 'pi-calendar'"></i></span>
        <div class="ai-appt__body">
          <strong class="ai-appt__title">{{ a.title || (a.is_inspection ? 'Inspection' : 'Appointment') }}</strong>
          <span class="ai-appt__when" *ngIf="appointmentWhen(a)">{{ appointmentWhen(a) }}</span>
          <span class="ai-appt__tags">
            <span class="ai-chip ai-chip--soft" *ngIf="a.is_inspection">Inspection</span>
            <span class="ai-chip ai-chip--soft" *ngIf="a.type">{{ a.type }}</span>
          </span>
        </div>
      </button>
    </div>

    <!-- ============================== day_briefing ============================ -->
    <div class="ai-view-block ai-day" *ngSwitchCase="'day_briefing'">
      <h6 class="ai-stats__title">
        {{ asDayBriefing(view).greeting_name ? 'Here’s your day, ' + asDayBriefing(view).greeting_name : 'Here’s your day' }}
      </h6>

      <div class="ai-day__group">
        <div class="ai-day__head">
          <span class="ai-day__label"><i class="pi pi-bell"></i> Follow-ups today</span>
          <span class="ai-chip">{{ asDayBriefing(view).follow_ups_today?.count || 0 }}</span>
        </div>
        <button
          type="button"
          class="ai-day__item"
          *ngFor="let it of asDayBriefing(view).follow_ups_today?.items; trackBy: trackByIndex"
          [class.ai-day__item--clickable]="briefingItemId(it)"
          (click)="briefingItemId(it) && emitOpenLead(briefingItemId(it), it.project_id)">
          <span class="ai-day__row">
            <span class="ai-day__name">{{ it.name || 'Lead' }}</span>
            <span class="ai-day__when" *ngIf="briefingItemWhen(it)">{{ briefingItemWhen(it) }}</span>
          </span>
          <span class="ai-day__meta" *ngIf="briefingStatus(it) || briefingType(it)">
            <span class="ai-tag ai-tag--status" *ngIf="briefingStatus(it)">{{ briefingStatus(it) }}</span>
            <span class="ai-tag ai-tag--type" *ngIf="briefingType(it)">{{ briefingType(it) }}</span>
          </span>
        </button>
      </div>

      <div class="ai-day__group" *ngIf="asDayBriefing(view).follow_ups_overdue?.count">
        <div class="ai-day__head">
          <span class="ai-day__label ai-day__label--warn"><i class="pi pi-exclamation-circle"></i> Overdue follow-ups</span>
          <span class="ai-chip ai-chip--warn">{{ asDayBriefing(view).follow_ups_overdue?.count }}</span>
        </div>
        <button
          type="button"
          class="ai-day__item"
          *ngFor="let it of asDayBriefing(view).follow_ups_overdue?.items; trackBy: trackByIndex"
          [class.ai-day__item--clickable]="briefingItemId(it)"
          (click)="briefingItemId(it) && emitOpenLead(briefingItemId(it), it.project_id)">
          <span class="ai-day__row">
            <span class="ai-day__name">{{ it.name || 'Lead' }}</span>
            <span class="ai-day__when ai-day__when--warn" *ngIf="briefingItemWhen(it)">{{ briefingItemWhen(it) }}</span>
          </span>
          <span class="ai-day__meta" *ngIf="briefingStatus(it) || briefingType(it)">
            <span class="ai-tag ai-tag--status" *ngIf="briefingStatus(it)">{{ briefingStatus(it) }}</span>
            <span class="ai-tag ai-tag--type" *ngIf="briefingType(it)">{{ briefingType(it) }}</span>
          </span>
        </button>
        <button type="button" class="ai-btn ai-btn--ghost ai-day__action" (click)="pickPrompt.emit('Close my overdue follow-ups')">
          <i class="pi pi-check-circle"></i> Close overdue follow-ups
        </button>
      </div>

      <div class="ai-day__group">
        <div class="ai-day__head">
          <span class="ai-day__label"><i class="pi pi-user-plus"></i> New leads today</span>
          <span class="ai-chip">{{ asDayBriefing(view).new_leads_today?.count || 0 }}</span>
        </div>
        <button
          type="button"
          class="ai-day__item"
          *ngFor="let it of asDayBriefing(view).new_leads_today?.items; trackBy: trackByIndex"
          [class.ai-day__item--clickable]="briefingItemId(it)"
          (click)="briefingItemId(it) && emitOpenLead(briefingItemId(it), it.project_id)">
          <span class="ai-day__row">
            <span class="ai-day__name">{{ it.name || 'Lead' }}</span>
          </span>
          <span class="ai-day__meta" *ngIf="briefingStatus(it) || briefingType(it)">
            <span class="ai-tag ai-tag--status" *ngIf="briefingStatus(it)">{{ briefingStatus(it) }}</span>
            <span class="ai-tag ai-tag--type" *ngIf="briefingType(it)">{{ briefingType(it) }}</span>
          </span>
        </button>
      </div>

      <div class="ai-day__group">
        <div class="ai-day__head">
          <span class="ai-day__label">
            <i class="pi pi-calendar"></i> Appointments today
            <span class="ai-day__sub" *ngIf="asDayBriefing(view).appointments_today?.inspections">
              · {{ asDayBriefing(view).appointments_today?.inspections }} inspection{{
                asDayBriefing(view).appointments_today?.inspections === 1 ? '' : 's'
              }}
            </span>
          </span>
          <span class="ai-chip">{{ asDayBriefing(view).appointments_today?.count || 0 }}</span>
        </div>
        <button
          type="button"
          class="ai-day__item ai-day__item--clickable"
          *ngFor="let it of asDayBriefing(view).appointments_today?.items; trackBy: trackByIndex"
          (click)="openAppointmentLead(appointmentLeadId(it))">
          <span class="ai-day__row">
            <span class="ai-day__name">{{ it.title || it.name || 'Appointment' }}</span>
            <span class="ai-day__when" *ngIf="appointmentItemWhen(it)">{{ appointmentItemWhen(it) }}</span>
          </span>
          <span class="ai-day__meta" *ngIf="it.is_inspection || it.type">
            <span class="ai-tag ai-tag--status" *ngIf="it.is_inspection">Inspection</span>
            <span class="ai-tag ai-tag--type" *ngIf="it.type">{{ it.type }}</span>
          </span>
        </button>
      </div>
    </div>

    <!-- ============================ follow_ups_moved ========================== -->
    <div class="ai-view-block ai-created" *ngSwitchCase="'follow_ups_moved'">
      <div class="ai-created__head">
        <span class="ai-created__icon"><i class="pi pi-clock"></i></span>
        <div>
          <strong>{{ asFollowUpsMoved(view).count }} follow-up{{ asFollowUpsMoved(view).count === 1 ? '' : 's' }} moved</strong>
          <span class="ai-created__name" *ngIf="movedWhen(view)">to {{ movedWhen(view) }}</span>
        </div>
      </div>
      <div class="ai-created__meta" *ngIf="asFollowUpsMoved(view).items?.length">
        <span class="ai-chip ai-chip--soft" *ngFor="let it of asFollowUpsMoved(view).items">{{ it.name || 'Lead' }}</span>
      </div>
    </div>

    <!-- ============================== leads_closed ============================ -->
    <div class="ai-view-block ai-created" *ngSwitchCase="'leads_closed'">
      <div class="ai-created__head">
        <span class="ai-created__icon"><i class="pi pi-check-circle"></i></span>
        <div>
          <strong>{{ asLeadsClosed(view).count }} lead{{ asLeadsClosed(view).count === 1 ? '' : 's' }} closed</strong>
          <span class="ai-created__name" *ngIf="asLeadsClosed(view).reason">as {{ asLeadsClosed(view).reason }}</span>
        </div>
      </div>
      <div class="ai-created__meta" *ngIf="asLeadsClosed(view).items?.length">
        <span class="ai-chip ai-chip--soft" *ngFor="let it of asLeadsClosed(view).items">{{ bulkItemName(it) }}</span>
      </div>
      <p class="ai-created__warn" *ngIf="asLeadsClosed(view).failed_count as failed">
        <i class="pi pi-exclamation-triangle"></i> {{ failed }} couldn’t be closed
      </p>
    </div>

    <!-- ============================= leads_updated ============================ -->
    <div class="ai-view-block ai-created" *ngSwitchCase="'leads_updated'">
      <div class="ai-created__head">
        <span class="ai-created__icon"><i class="pi pi-check-circle"></i></span>
        <div>
          <strong>{{ asLeadsUpdated(view).count }} lead{{ asLeadsUpdated(view).count === 1 ? '' : 's' }} updated</strong>
        </div>
      </div>
      <div class="ai-created__meta" *ngIf="updateChanges(asLeadsUpdated(view)).length">
        <span class="ai-tag ai-tag--status" *ngFor="let change of updateChanges(asLeadsUpdated(view))">{{ change }}</span>
      </div>
      <div class="ai-created__meta" *ngIf="asLeadsUpdated(view).items?.length">
        <span class="ai-chip ai-chip--soft" *ngFor="let it of asLeadsUpdated(view).items">{{ bulkItemName(it) }}</span>
      </div>
      <p class="ai-created__warn" *ngIf="asLeadsUpdated(view).failed_count as failed">
        <i class="pi pi-exclamation-triangle"></i> {{ failed }} couldn’t be updated
      </p>
    </div>

    <!-- ========================== follow_ups_completed ======================== -->
    <div class="ai-view-block ai-created" *ngSwitchCase="'follow_ups_completed'">
      <div class="ai-created__head">
        <span class="ai-created__icon"><i class="pi pi-check-circle"></i></span>
        <div>
          <strong> {{ asFollowUpsCompleted(view).count }} follow-up{{ asFollowUpsCompleted(view).count === 1 ? '' : 's' }} completed </strong>
        </div>
      </div>
      <div class="ai-created__meta" *ngIf="asFollowUpsCompleted(view).items?.length">
        <span class="ai-chip ai-chip--soft" *ngFor="let it of asFollowUpsCompleted(view).items">{{ bulkItemName(it) }}</span>
      </div>
      <p class="ai-created__warn" *ngIf="asFollowUpsCompleted(view).failed_count as failed">
        <i class="pi pi-exclamation-triangle"></i> {{ failed }} couldn’t be completed
      </p>
    </div>

    <!-- ============================ follow_ups_added ========================== -->
    <div class="ai-view-block ai-created" *ngSwitchCase="'follow_ups_added'">
      <div class="ai-created__head">
        <span class="ai-created__icon"><i class="pi pi-bell"></i></span>
        <div>
          <strong>{{ asFollowUpsAdded(view).count }} follow-up{{ asFollowUpsAdded(view).count === 1 ? '' : 's' }} scheduled</strong>
          <span class="ai-created__name" *ngIf="addedWhen(view)">for {{ addedWhen(view) }}</span>
        </div>
      </div>
      <div class="ai-created__meta" *ngIf="asFollowUpsAdded(view).items?.length">
        <span class="ai-chip ai-chip--soft" *ngFor="let it of asFollowUpsAdded(view).items">{{ bulkItemName(it) }}</span>
      </div>
      <p class="ai-created__warn" *ngIf="asFollowUpsAdded(view).failed_count as failed">
        <i class="pi pi-exclamation-triangle"></i> {{ failed }} couldn’t be scheduled
      </p>
    </div>

    <!-- =============================== lead_stats ============================== -->
    <div class="ai-view-block ai-stats" *ngSwitchCase="'lead_stats'">
      <div class="ai-stats__total">
        <span class="ai-stats__total-value">{{ asLeadStats(view).total }}</span>
        <span class="ai-stats__total-label">total leads</span>
      </div>
      <div class="ai-stats__group" *ngIf="asLeadStats(view).by_status?.length">
        <h6 class="ai-stats__title">By status</h6>
        <div class="ai-bar" *ngFor="let b of asLeadStats(view).by_status">
          <div class="ai-bar__top">
            <span class="ai-bar__label">{{ b.value }}</span>
            <span class="ai-bar__count">{{ b.count }}</span>
          </div>
          <span class="ai-bar__track"><span class="ai-bar__fill" [style.width]="barWidth(b.count, asLeadStats(view).by_status)"></span></span>
        </div>
      </div>
      <div class="ai-stats__group" *ngIf="asLeadStats(view).by_type?.length">
        <h6 class="ai-stats__title">By type</h6>
        <div class="ai-bar" *ngFor="let b of asLeadStats(view).by_type">
          <div class="ai-bar__top">
            <span class="ai-bar__label">{{ b.value }}</span>
            <span class="ai-bar__count">{{ b.count }}</span>
          </div>
          <span class="ai-bar__track"
            ><span class="ai-bar__fill ai-bar__fill--alt" [style.width]="barWidth(b.count, asLeadStats(view).by_type)"></span
          ></span>
        </div>
      </div>
    </div>

    <!-- ============================== contact_list ============================= -->
    <div class="ai-view-block" *ngSwitchCase="'contact_list'">
      <div class="ai-list__head">
        <span class="ai-list__count">{{ asContactList(view).total }} contact{{ asContactList(view).total === 1 ? '' : 's' }}</span>
      </div>
      <div class="ai-contact" *ngFor="let c of asContactList(view).items; trackBy: trackById">
        <span class="ai-contact__avatar">{{ initials(c.name) }}</span>
        <div class="ai-contact__body">
          <strong class="ai-contact__name">{{ c.name || 'Contact' }}</strong>
          <span class="ai-contact__sub" *ngIf="contactCompany(c)">{{ contactCompany(c) }}</span>
          <div class="ai-contact__links">
            <a *ngIf="c.phone" [href]="telHref(c.phone)"><i class="pi pi-phone"></i> {{ c.phone }}</a>
            <a *ngIf="c.email" [href]="mailtoHref(c.email)"><i class="pi pi-envelope"></i> {{ c.email }}</a>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="ai-btn ai-btn--ghost ai-more"
        *ngIf="asContactList(view).has_more"
        (click)="pickPrompt.emit('Show the next 10 contacts')">
        <i class="pi pi-angle-down"></i> Show more
      </button>
    </div>

    <!-- =============================== lead_grid =============================== -->
    <div class="ai-view-block ai-grid-block" *ngSwitchCase="'lead_grid'">
      <div class="ai-list__head">
        <span class="ai-list__count">{{ asLeadGrid(view).total }} leads</span>
        <span class="ai-grid__view" *ngIf="asLeadGrid(view).view as v">· {{ v.name }}</span>
      </div>
      <div class="ai-grid__scroll">
        <table class="ai-grid">
          <thead>
            <tr>
              <th *ngFor="let col of visibleColumns(asLeadGrid(view)); trackBy: trackByIndex">{{ col.column }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let row of asLeadGrid(view).rows; trackBy: trackByIndex"
              [class.ai-grid__row--clickable]="row._id"
              (click)="row._id && emitOpenLead(row._id, row.project_id)">
              <td *ngFor="let col of visibleColumns(asLeadGrid(view)); trackBy: trackByIndex">{{ cellText(row, col.field) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <button
        type="button"
        class="ai-btn ai-btn--ghost ai-more"
        *ngIf="asLeadGrid(view).page < asLeadGrid(view).total_pages"
        (click)="pickPrompt.emit('Show page ' + (asLeadGrid(view).page + 1))">
        <i class="pi pi-angle-down"></i> Show page {{ asLeadGrid(view).page + 1 }}
      </button>
    </div>

    <!-- =============================== lead_views ============================== -->
    <div class="ai-view-block ai-saved-views" *ngSwitchCase="'lead_views'">
      <h6 class="ai-stats__title">Saved views</h6>
      <button
        type="button"
        class="ai-saved-view"
        [class.ai-saved-view--selected]="lv.selected"
        *ngFor="let lv of asLeadViews(view).items; trackBy: trackById"
        (click)="pickPrompt.emit('Switch to the &quot;' + lv.name + '&quot; view')">
        <i class="pi" [ngClass]="lv.selected ? 'pi-check-circle' : 'pi-table'"></i>
        <span class="ai-saved-view__name">{{ lv.name }}</span>
        <span class="ai-chip ai-chip--soft" *ngIf="lv.is_default">Default</span>
      </button>
    </div>

    <!-- ============================ lead_view_saved =========================== -->
    <div class="ai-view-block ai-created" *ngSwitchCase="'lead_view_saved'">
      <div class="ai-created__head">
        <span class="ai-created__icon"><i class="pi pi-check-circle"></i></span>
        <div>
          <strong>View saved</strong>
          <span class="ai-created__name">{{ asLeadViewSaved(view).item.name }}</span>
        </div>
      </div>
      <div class="ai-created__meta" *ngIf="asLeadViewSaved(view).item.columns?.length">
        <span class="ai-chip ai-chip--soft" *ngFor="let col of asLeadViewSaved(view).item.columns">{{ humanizeField(col) }}</span>
      </div>
    </div>

    <!-- ============================== capabilities ============================= -->
    <div class="ai-view-block ai-caps" *ngSwitchCase="'capabilities'">
      <h6 class="ai-stats__title">What I can help with</h6>
      <div class="ai-cap" *ngFor="let cat of asCapabilities(view).available_categories; trackBy: trackByIndex" [class.ai-cap--off]="!cat.available">
        <div class="ai-cap__head">
          <strong>{{ cat.category }}</strong>
          <span class="ai-chip ai-chip--soft" *ngIf="!cat.available">Coming soon</span>
        </div>
        <div class="ai-cap__examples" *ngIf="cat.available && cat.examples?.length">
          <button type="button" class="ai-example" *ngFor="let ex of cat.examples" (click)="pickPrompt.emit(ex)">
            {{ ex }}
          </button>
        </div>
      </div>
      <div class="ai-caps__soon" *ngIf="asCapabilities(view).coming_soon?.length">
        <i class="pi pi-clock"></i> Coming soon: {{ asCapabilities(view).coming_soon?.join(', ') }}
      </div>
      <div class="ai-cap__examples" *ngIf="asCapabilities(view).suggested_prompts?.length">
        <button
          type="button"
          class="ai-example ai-example--accent"
          *ngFor="let sp of asCapabilities(view).suggested_prompts"
          (click)="pickPrompt.emit(sp.prompt)">
          {{ sp.label }}
        </button>
      </div>
    </div>

    <!-- ===== projects: project_list / lot_list / eoi_list / project_task_list / project_event_list ===== -->
    <ng-container *ngSwitchCase="'project_list'">
      <ng-container *ngTemplateOutlet="projectListTpl; context: { $implicit: asProject(view) }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'lot_list'">
      <ng-container *ngTemplateOutlet="projectListTpl; context: { $implicit: asProject(view) }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'eoi_list'">
      <ng-container *ngTemplateOutlet="projectListTpl; context: { $implicit: asProject(view) }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'project_task_list'">
      <ng-container *ngTemplateOutlet="projectListTpl; context: { $implicit: asProject(view) }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'project_event_list'">
      <ng-container *ngTemplateOutlet="projectListTpl; context: { $implicit: asProject(view) }"></ng-container>
    </ng-container>

    <!-- ============================= project_detail =========================== -->
    <div class="ai-view-block ai-proj" *ngSwitchCase="'project_detail'">
      <h6 class="ai-stats__title"><i class="pi pi-building"></i> {{ projectHeading(asProject(view)) }}</h6>
      <ul class="ai-proj__rows" *ngIf="projectDetailRows(asProject(view)).length">
        <li *ngFor="let row of projectDetailRows(asProject(view)); trackBy: trackByIndex">
          <span class="ai-proj__label">{{ row.label }}</span>
          <span class="ai-proj__value">{{ row.value }}</span>
        </li>
      </ul>
    </div>
  </ng-container>
</div>

<!-- ===================== reusable: a paginated lead list ===================== -->
<ng-template #leadListTpl let-list>
  <div class="ai-view-block">
    <div class="ai-list__head">
      <span class="ai-list__count">{{ list.total }} lead{{ list.total === 1 ? '' : 's' }}</span>
    </div>
    <p class="ai-list__hint" *ngIf="list.ambiguous"><i class="pi pi-info-circle"></i> More than one lead matches — pick the right one to continue.</p>
    <ng-container *ngFor="let lead of list.items; trackBy: trackById">
      <ng-container *ngTemplateOutlet="leadCardTpl; context: { $implicit: lead, detail: false }"></ng-container>
    </ng-container>
    <button type="button" class="ai-btn ai-btn--ghost ai-more" *ngIf="list.has_more" (click)="pickPrompt.emit('Show the next 10')">
      <i class="pi pi-angle-down"></i> Show more
    </button>
  </div>
</ng-template>

<!-- ============ reusable: a write-confirmation card (update / follow-up / etc.) ============ -->
<ng-template #confirmTpl let-c>
  <div class="ai-view-block ai-created">
    <div class="ai-created__head">
      <span class="ai-created__icon"><i class="pi" [ngClass]="c.icon"></i></span>
      <div>
        <strong>{{ c.title }}</strong>
        <span class="ai-created__name" *ngIf="c.name">{{ c.name }}</span>
      </div>
    </div>
    <div class="ai-created__meta" *ngIf="c.meta?.length">
      <span class="ai-chip" *ngFor="let m of c.meta">{{ m }}</span>
    </div>
    <div class="ai-view-actions" *ngIf="c.leadId">
      <button type="button" class="ai-btn ai-btn--primary" (click)="emitOpenLead(c.leadId, c.projectId)">
        <i class="pi pi-external-link"></i> Open Lead
      </button>
    </div>
  </div>
</ng-template>

<!-- ======= reusable: a project list (projects / lots / EOIs / tasks / events) ======= -->
<ng-template #projectListTpl let-view>
  <div class="ai-view-block ai-proj">
    <div class="ai-list__head">
      <span class="ai-list__count"><i class="pi" [ngClass]="projectIcon(view)"></i> {{ projectHeading(view) }}</span>
      <span class="ai-chip ai-chip--soft" *ngIf="view.total != null">{{ view.total }}</span>
    </div>

    <p class="ai-list__count" *ngIf="!projectItems(view).length">Nothing to show.</p>

    <div class="ai-proj__item" *ngFor="let it of projectItems(view); trackBy: trackByIndex">
      <span class="ai-proj__title">{{ it.title }}</span>
      <span class="ai-proj__meta" *ngIf="it.meta.length">
        <span class="ai-chip ai-chip--soft" *ngFor="let m of it.meta">{{ m }}</span>
      </span>
    </div>

    <button
      type="button"
      class="ai-btn ai-btn--ghost ai-more"
      *ngIf="projectHasMore(view)"
      (click)="pickPrompt.emit('Show page ' + ((view.page || 1) + 1))">
      <i class="pi pi-angle-down"></i> Show more
    </button>
  </div>
</ng-template>

<!-- ===================== reusable: a single lead card ====================== -->
<ng-template #leadCardTpl let-lead let-detail="detail">
  <div class="ai-lead-card" [class.ai-lead-card--clickable]="lead.id" (click)="lead.id && emitOpenLead(lead.id, lead.project_id)">
    <div class="ai-lead-card__head">
      <span class="ai-lead-card__avatar">{{ initials(lead.name) }}</span>
      <div class="ai-lead-card__heading">
        <strong>{{ lead.name || 'Lead' }}</strong>
        <span class="ai-lead-card__sub" *ngIf="leadSubtitle(lead)">{{ leadSubtitle(lead) }}</span>
      </div>
      <span class="ai-lead-card__temp" [ngClass]="temperatureClass(lead)" *ngIf="lead.temperature">{{ lead.temperature }}</span>
    </div>

    <div class="ai-lead-card__grid">
      <div class="ai-lead-card__field">
        <label>Phone</label>
        <span>{{ lead.phone || '—' }}</span>
      </div>
      <div class="ai-lead-card__field">
        <label>Email</label>
        <span>{{ lead.email || '—' }}</span>
      </div>
      <div class="ai-lead-card__field">
        <label>Lead Source</label>
        <span>{{ lead.lead_source || '—' }}</span>
      </div>
      <div class="ai-lead-card__field">
        <label>Lead Type</label>
        <span>{{ lead.lead_type || '—' }}</span>
      </div>
      <div class="ai-lead-card__field" *ngIf="lead.assigned_agent">
        <label>Assigned Agent</label>
        <span>{{ lead.assigned_agent }}</span>
      </div>
      <div class="ai-lead-card__field" *ngIf="detail && lead.follow_up_date">
        <label>Follow-up</label>
        <span>{{ lead.follow_up_date | aiFriendlyDate }}</span>
      </div>
    </div>

    <div class="ai-lead-card__actions" (click)="$event.stopPropagation()">
      <button type="button" class="ai-btn ai-btn--primary" (click)="emitOpenLead(lead.id, lead.project_id)">Open Lead</button>
      <a class="ai-btn ai-btn--ghost" *ngIf="lead.phone" [href]="telHref(lead.phone)"><i class="pi pi-phone"></i> Call</a>
      <a class="ai-btn ai-btn--ghost" *ngIf="lead.email" [href]="mailtoHref(lead.email)"><i class="pi pi-envelope"></i> Email</a>
    </div>
  </div>
</ng-template>
